/* ============================================
   BEAUTIQ PREMIUM THEME - Main JavaScript
   ============================================ */

'use strict';

// ---- Utility ----
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const $$ = (sel, ctx = document) => [...ctx.querySelectorAll(sel)];

function formatMoney(cents) {
  const amount = (cents / 100).toFixed(2);
  return `AED ${amount}`;
}

function debounce(fn, ms = 300) {
  let t;
  return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), ms); };
}

// ---- Toast notifications ----
function showToast(msg, type = 'success') {
  let toast = $('#beautiq-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'beautiq-toast';
    toast.className = 'toast';
    document.body.appendChild(toast);
  }
  toast.className = `toast toast--${type}`;
  toast.innerHTML = `<span class="toast__icon">${type === 'success' ? '✓' : '✕'}</span>${msg}`;
  requestAnimationFrame(() => toast.classList.add('visible'));
  setTimeout(() => toast.classList.remove('visible'), 3500);
}

// ---- Announcement Slider ----
function initAnnouncementSlider() {
  const el = $('.announcement-bar__slider');
  if (!el) return;
  if (typeof Swiper === 'undefined') return;
  new Swiper(el, {
    loop: true,
    autoplay: { delay: 3500, disableOnInteraction: false },
    speed: 600,
    direction: 'vertical',
    allowTouchMove: false
  });
}

// ---- Header scroll behaviour ----
function initHeader() {
  const header = $('.site-header');
  if (!header) return;
  const isTransparent = header.classList.contains('transparent');

  function onScroll() {
    if (isTransparent) {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }
    // Sticky ATC
    const stickyAtc = $('.sticky-atc');
    if (stickyAtc) {
      const trigger = $('.product-atc, .product-atc--full');
      if (trigger) {
        const rect = trigger.getBoundingClientRect();
        stickyAtc.classList.toggle('visible', rect.bottom < 0);
      }
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
}

// ---- Mobile nav ----
function initMobileNav() {
  const toggle = $('.mobile-menu-toggle');
  const nav = $('.mobile-nav');
  const overlay = $('.mobile-nav__overlay');
  const close = $('.mobile-nav__close');
  if (!toggle || !nav) return;

  function open() {
    const scrollY = window.scrollY;
    nav.classList.add('open');
    overlay && overlay.classList.add('visible');
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    document.body.dataset.scrollY = scrollY;
  }
  function close_nav() {
    const scrollY = document.body.dataset.scrollY || 0;
    nav.classList.remove('open');
    overlay && overlay.classList.remove('visible');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, parseInt(scrollY));
  }

  toggle.addEventListener('click', open);
  close && close.addEventListener('click', close_nav);
  overlay && overlay.addEventListener('click', close_nav);

  // Sub-menu toggles
  $$('.mobile-nav__link').forEach(link => {
    link.addEventListener('click', e => {
      const sub = link.nextElementSibling;
      if (sub && sub.classList.contains('mobile-nav__sub')) {
        e.preventDefault();
        sub.classList.toggle('open');
        const arrow = link.querySelector('svg');
        if (arrow) arrow.style.transform = sub.classList.contains('open') ? 'rotate(180deg)' : '';
      }
    });
  });
}

// ---- Search overlay ----
function initSearch() {
  const btns = $$('[data-search-toggle]');
  const overlay = $('.search-overlay');
  const closeBtn = $('.search-overlay__close');
  const input = $('.search-overlay__input');
  if (!overlay) return;

  function openSearch() {
    overlay.classList.add('open');
    lockBody();
    setTimeout(() => input && input.focus(), 300);
  }
  function closeSearch() {
    overlay.classList.remove('open');
    unlockBody();
  }

  btns.forEach(btn => btn.addEventListener('click', openSearch));
  closeBtn && closeBtn.addEventListener('click', closeSearch);
  overlay.addEventListener('click', e => { if (e.target === overlay) closeSearch(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeSearch(); });
}

// ---- Cart Drawer ----
function initCartDrawer() {
  const drawer = $('.cart-drawer');
  const overlay = $('.cart-overlay');
  if (!drawer) return;

  function openCart() {
    drawer.classList.add('open');
    overlay && overlay.classList.add('visible');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }
  function closeCart() {
    drawer.classList.remove('open');
    overlay && overlay.classList.remove('visible');
    document.body.style.overflow = '';
  }

  $$('[data-cart-toggle]').forEach(btn => btn.addEventListener('click', openCart));
  overlay && overlay.addEventListener('click', closeCart);
  const closeBtn = $('.cart-drawer__close');
  closeBtn && closeBtn.addEventListener('click', closeCart);

  // Gift note toggle
  const giftToggle = $('.cart-gift-note__toggle');
  const giftTextarea = $('.cart-gift-note__textarea');
  giftToggle && giftToggle.addEventListener('click', () => {
    giftTextarea && giftTextarea.classList.toggle('open');
  });

  window.openCartDrawer = openCart;
  window.closeCartDrawer = closeCart;
}

async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
    updateShippingProgress(cart.total_price);
  } catch (e) { console.error('Cart refresh error', e); }
}

function renderCart(cart) {
  const body = $('.cart-drawer__body');
  const subtotalEl = $('.cart-subtotal__value');
  const countEl = $('.cart-drawer__count');
  if (!body) return;

  if (countEl) countEl.textContent = cart.item_count;
  if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

  if (cart.item_count === 0) {
    body.innerHTML = `
      <div class="cart-empty">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 001.98 1.61h9.72a2 2 0 001.98-1.61L23 6H6"/></svg>
        <h3>Your bag is empty</h3>
        <p>Discover our luxury beauty collection</p>
        <a href="/collections/all" class="btn btn-primary" onclick="closeCartDrawer()">Shop Now</a>
      </div>`;
    return;
  }

  const itemsHtml = cart.items.map(item => `
    <div class="cart-item" data-id="${item.key}">
      <div class="cart-item__image"><img src="${item.image}" alt="${item.product_title}" loading="lazy"></div>
      <div class="cart-item__details">
        <div class="cart-item__title">${item.product_title}</div>
        ${item.variant_title ? `<div class="cart-item__variant">${item.variant_title}</div>` : ''}
        <div class="cart-item__price">
          ${item.original_line_price !== item.final_line_price ? `<span class="original">${formatMoney(item.original_line_price)}</span>` : ''}
          <span class="${item.original_line_price !== item.final_line_price ? 'sale' : ''}">${formatMoney(item.final_line_price)}</span>
        </div>
        <div class="cart-item__actions">
          <div class="cart-item__qty">
            <button class="qty-dec" data-id="${item.key}">−</button>
            <span>${item.quantity}</span>
            <button class="qty-inc" data-id="${item.key}">+</button>
          </div>
          <button class="cart-item__remove" data-id="${item.key}">Remove</button>
        </div>
      </div>
    </div>`).join('');

  const existingEmpty = body.querySelector('.cart-empty');
  if (existingEmpty) body.innerHTML = '';
  
  let itemsContainer = body.querySelector('.cart-items');
  if (!itemsContainer) {
    itemsContainer = document.createElement('div');
    itemsContainer.className = 'cart-items';
    body.insertBefore(itemsContainer, body.firstChild);
  }
  itemsContainer.innerHTML = itemsHtml;

  // qty controls
  body.querySelectorAll('.qty-dec').forEach(btn => {
    btn.addEventListener('click', () => updateCartItem(btn.dataset.id, -1));
  });
  body.querySelectorAll('.qty-inc').forEach(btn => {
    btn.addEventListener('click', () => updateCartItem(btn.dataset.id, 1));
  });
  body.querySelectorAll('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', () => removeCartItem(btn.dataset.id));
  });
}

async function updateCartItem(key, delta) {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const item = cart.items.find(i => i.key === key);
  if (!item) return;
  const newQty = item.quantity + delta;
  if (newQty <= 0) { removeCartItem(key); return; }
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: newQty })
  });
  await refreshCart();
}

async function removeCartItem(key) {
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  });
  await refreshCart();
}

function updateCartCount(count) {
  $$('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? 'flex' : 'none';
  });
}

function updateShippingProgress(totalPrice) {
  const FREE_SHIPPING_THRESHOLD = 19900; // AED 199 in cents
  const bar = $('.shipping-progress__bar');
  const text = $('.shipping-progress__text');
  if (!bar) return;
  const pct = Math.min(100, (totalPrice / FREE_SHIPPING_THRESHOLD) * 100);
  bar.style.width = pct + '%';
  if (text) {
    if (totalPrice >= FREE_SHIPPING_THRESHOLD) {
      text.textContent = '🎉 You have free shipping!';
    } else {
      const remaining = formatMoney(FREE_SHIPPING_THRESHOLD - totalPrice);
      text.textContent = `Spend ${remaining} more for free shipping`;
    }
  }
}

// ---- Add to Cart ----
async function addToCart(variantId, qty = 1, properties = {}) {
  const btn = $('[data-add-to-cart]');
  if (btn) btn.classList.add('loading');
  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty, properties })
    });
    const data = await res.json();
    if (data.status) throw new Error(data.description || 'Error adding to cart');
    showToast('Added to your bag!', 'success');
    window.openCartDrawer && window.openCartDrawer();
    return data;
  } catch (e) {
    showToast(e.message || 'Could not add item', 'error');
    throw e;
  } finally {
    if (btn) btn.classList.remove('loading');
  }
}

function initProductPage() {
  const form = $('[data-product-form]');
  if (!form) return;

  // Handle form submission (ATC)
  form.addEventListener('submit', async e => {
    e.preventDefault();
    const variantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const variantId = variantInput ? variantInput.value : null;
    const qty = qtyInput ? parseInt(qtyInput.value) : 1;
    if (!variantId || variantId === '') { showToast('Please select options', 'error'); return; }
    await addToCart(variantId, qty);
  });

  // Variant selection
  const variantInputs = $$('[data-variant-input]', form);
  variantInputs.forEach(input => {
    input.addEventListener('change', updateVariant);
  });

  // Swatch selection
  $$('[data-swatch]').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const group = swatch.closest('[data-option-group]');
      if (group) $$('[data-swatch]', group).forEach(s => s.classList.remove('active'));
      swatch.classList.add('active');
      const input = group ? group.querySelector('[data-variant-value]') : null;
      if (input) { input.value = swatch.dataset.swatch; updateVariant(); }
    });
  });

  // Gallery thumbnails
  $$('.product-gallery__thumb').forEach((thumb, i) => {
    thumb.addEventListener('click', () => {
      const mainImg = $('.product-gallery__main img');
      const fullSrc = thumb.dataset.full || thumb.querySelector('img').src;
      if (mainImg) mainImg.src = fullSrc;
      $$('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });

  // Zoom/Lightbox
  const zoomBtn = $('.product-gallery__zoom');
  const lightbox = $('.product-lightbox');
  const lightboxImg = $('.product-lightbox__img');
  const lightboxClose = $('.product-lightbox__close');
  if (zoomBtn && lightbox) {
    zoomBtn.addEventListener('click', () => {
      const mainImg = $('.product-gallery__main img');
      if (lightboxImg && mainImg) lightboxImg.src = mainImg.src;
      lightbox.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
    lightboxClose && lightboxClose.addEventListener('click', () => {
      lightbox.classList.remove('open');
      document.body.style.overflow = '';
    });
    lightbox.addEventListener('click', e => {
      if (e.target === lightbox) { lightbox.classList.remove('open'); document.body.style.overflow = ''; }
    });
  }

  // Qty selector
  $$('.qty-selector button').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-selector').querySelector('input');
      if (!input) return;
      const val = parseInt(input.value) || 1;
      if (btn.classList.contains('qty-dec') && val > 1) input.value = val - 1;
      if (btn.classList.contains('qty-inc')) input.value = val + 1;
    });
  });

  // Accordion
  $$('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const body = trigger.nextElementSibling;
      const isOpen = trigger.classList.contains('open');
      trigger.classList.toggle('open', !isOpen);
      if (body) {
        body.style.maxHeight = isOpen ? '0' : body.scrollHeight + 'px';
        body.style.overflow = 'hidden';
        body.style.transition = 'max-height 0.35s ease';
      }
    });
  });

  // Wishlist btn
  $$('[data-wishlist-btn]').forEach(btn => {
    btn.addEventListener('click', () => {
      btn.classList.toggle('active');
      showToast(btn.classList.contains('active') ? 'Added to wishlist' : 'Removed from wishlist');
    });
  });
}

function updateVariant() {
  // Variant matching logic
  const optionValues = $$('[data-variant-value]').map(el => el.value);
  const variantData = window.__beautiq_variants;
  if (!variantData) return;

  const match = variantData.find(v => {
    return optionValues.every((val, i) => v.options[i] === val || !val);
  });

  const priceEl = $('.product-info__price');
  const compareEl = $('.product-info__compare');
  const stockEl = $('.stock-indicator__text');
  const stockDot = $('.stock-dot');
  const atcBtn = $('[data-add-to-cart]');
  const variantInput = $('[name="id"]');

  if (!match) {
    if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Unavailable'; }
    return;
  }

  if (variantInput) variantInput.value = match.id;
  if (priceEl) priceEl.textContent = formatMoney(match.price);
  if (compareEl) {
    if (match.compare_at_price && match.compare_at_price > match.price) {
      compareEl.textContent = formatMoney(match.compare_at_price);
      compareEl.style.display = '';
    } else {
      compareEl.style.display = 'none';
    }
  }
  if (atcBtn) {
    atcBtn.disabled = !match.available;
    atcBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
  }
  if (stockDot) {
    stockDot.className = 'stock-dot';
    stockDot.classList.add(match.available ? (match.inventory_quantity < 5 ? 'low-stock' : 'in-stock') : 'out-stock');
  }
  if (stockEl) stockEl.textContent = match.available ? (match.inventory_quantity < 5 ? `Only ${match.inventory_quantity} left` : 'In Stock') : 'Out of Stock';

  // Update gallery image if variant has image
  if (match.featured_image) {
    const mainImg = $('.product-gallery__main img');
    if (mainImg) mainImg.src = match.featured_image.src;
  }
}

// ---- Hero Slider ----
function initHeroSlider() {
  const el = $('.hero-slider .swiper');
  if (!el || typeof Swiper === 'undefined') return;
  new Swiper(el, {
    loop: true,
    speed: 900,
    autoplay: { delay: 5500, disableOnInteraction: false },
    pagination: { el: '.hero-slider .swiper-pagination', clickable: true },
    navigation: { nextEl: '.hero-slider .swiper-button-next', prevEl: '.hero-slider .swiper-button-prev' },
    effect: 'fade',
    fadeEffect: { crossFade: true }
  });
}

// ---- Products Slider ----
function initProductSliders() {
  $$('.products-slider .swiper').forEach(el => {
    if (typeof Swiper === 'undefined') return;
    new Swiper(el, {
      slidesPerView: 1.2,
      spaceBetween: 16,
      grabCursor: true,
      navigation: { nextEl: el.closest('.products-slider-wrap')?.querySelector('.swiper-button-next'), prevEl: el.closest('.products-slider-wrap')?.querySelector('.swiper-button-prev') },
      breakpoints: {
        480: { slidesPerView: 2.2 },
        768: { slidesPerView: 3.2 },
        1024: { slidesPerView: 4, spaceBetween: 24 },
        1200: { slidesPerView: 5, spaceBetween: 24 }
      }
    });
  });
}

// ---- Flash Sale Countdown ----
function initCountdowns() {
  $$('[data-countdown]').forEach(el => {
    const endTime = new Date(el.dataset.countdown).getTime();
    if (isNaN(endTime)) return;

    function update() {
      const now = Date.now();
      const diff = endTime - now;
      if (diff <= 0) { el.innerHTML = '<span>Sale ended</span>'; return; }

      const d = Math.floor(diff / 86400000);
      const h = Math.floor((diff % 86400000) / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);

      const pad = n => String(n).padStart(2, '0');
      const dEl = el.querySelector('[data-cd-days]');
      const hEl = el.querySelector('[data-cd-hours]');
      const mEl = el.querySelector('[data-cd-mins]');
      const sEl = el.querySelector('[data-cd-secs]');
      if (dEl) dEl.textContent = pad(d);
      if (hEl) hEl.textContent = pad(h);
      if (mEl) mEl.textContent = pad(m);
      if (sEl) sEl.textContent = pad(s);
    }
    update();
    setInterval(update, 1000);
  });
}

// ---- Brand Marquee ----
function initBrandMarquee() {
  const track = $('.brand-logos__track');
  if (!track) return;
  const clone = track.innerHTML;
  track.innerHTML += clone;
  let pos = 0;
  const speed = 0.5;
  function step() {
    pos -= speed;
    if (pos <= -(track.scrollWidth / 2)) pos = 0;
    track.style.transform = `translateX(${pos}px)`;
    requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}

// ---- Scroll Animations ----
function initScrollAnimations() {
  const els = $$('[data-animate]');
  if (!els.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) { e.target.classList.add('animated'); io.unobserve(e.target); } });
  }, { threshold: 0.05, rootMargin: '0px 0px 0px 0px' });
  els.forEach(el => io.observe(el));
}

// ---- Collection Filters ----
function initCollectionFilters() {
  const sidebar = $('.collection-sidebar');
  if (!sidebar) return;

  // Filter groups toggle
  $$('.filter-group__title').forEach(title => {
    title.addEventListener('click', () => {
      const body = title.nextElementSibling;
      title.classList.toggle('collapsed');
      body && body.classList.toggle('hidden');
    });
  });

  // Grid toggle
  $$('.grid-toggle-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      $$('.grid-toggle-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const grid = $('.products-grid');
      if (grid) {
        const cols = btn.dataset.cols || 4;
        grid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;
      }
    });
  });

  // Mobile filter drawer
  const mobileFilterToggle = $('[data-mobile-filter]');
  const filterDrawer = $('.filter-drawer');
  mobileFilterToggle && mobileFilterToggle.addEventListener('click', () => {
    filterDrawer && filterDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  });
  const filterClose = $('[data-filter-close]');
  filterClose && filterClose.addEventListener('click', () => {
    filterDrawer && filterDrawer.classList.remove('open');
    document.body.style.overflow = '';
  });
}

// ---- Quick Add ----
function initQuickAdd() {
  $$('[data-quick-add]').forEach(btn => {
    btn.addEventListener('click', async e => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) { showToast('Please select options', 'error'); return; }
      btn.classList.add('loading');
      try {
        await addToCart(variantId, 1);
      } catch (e) {
        // error handled in addToCart
      } finally {
        btn.classList.remove('loading');
      }
    });
  });
}

// ---- Wishlist ----
const WISHLIST_KEY = 'beautiq_wishlist';

function getWishlist() {
  try { return JSON.parse(localStorage.getItem(WISHLIST_KEY) || '[]'); } catch { return []; }
}
function saveWishlist(items) { localStorage.setItem(WISHLIST_KEY, JSON.stringify(items)); }

function initWishlist() {
  const wishlist = getWishlist();

  $$('[data-wishlist]').forEach(btn => {
    const pid = btn.dataset.wishlist;
    if (wishlist.includes(pid)) btn.classList.add('active');
    btn.addEventListener('click', () => {
      const list = getWishlist();
      const i = list.indexOf(pid);
      if (i === -1) { list.push(pid); showToast('Added to wishlist'); }
      else { list.splice(i, 1); showToast('Removed from wishlist'); }
      saveWishlist(list);
      btn.classList.toggle('active');
    });
  });
}

// ---- Before/After Slider ----
function initBeforeAfter() {
  $$('.before-after').forEach(el => {
    const handle = el.querySelector('.before-after__handle');
    const before = el.querySelector('.before-after__before');
    if (!handle || !before) return;
    let dragging = false;
    handle.addEventListener('mousedown', () => dragging = true);
    window.addEventListener('mouseup', () => dragging = false);
    window.addEventListener('mousemove', e => {
      if (!dragging) return;
      const rect = el.getBoundingClientRect();
      const pct = Math.max(0, Math.min(100, ((e.clientX - rect.left) / rect.width) * 100));
      handle.style.left = pct + '%';
      before.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
    });
    // touch
    handle.addEventListener('touchmove', e => {
      const rect = el.getBoundingClientRect();
      const pct = Math.max(0, Math.min(100, ((e.touches[0].clientX - rect.left) / rect.width) * 100));
      handle.style.left = pct + '%';
      before.style.clipPath = `inset(0 ${100 - pct}% 0 0)`;
    });
  });
}

// ---- Coupon / Discount ----
function initCartCoupon() {
  const form = $('.cart-coupon');
  if (!form) return;
  const btn = form.querySelector('.btn');
  const input = form.querySelector('input');
  btn && btn.addEventListener('click', async () => {
    const code = input ? input.value.trim() : '';
    if (!code) return;
    // Coupon codes are applied through checkout in Shopify
    showToast('Discount code will be applied at checkout', 'success');
    if (input) {
      const checkoutBtn = $('.cart-checkout-btn');
      if (checkoutBtn) {
        const url = new URL(checkoutBtn.href || '/checkout');
        url.searchParams.set('discount', code);
        checkoutBtn.href = url.toString();
      }
    }
  });
}

// ---- Video Section ----
function initVideoSection() {
  $$('.video-play-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const wrapper = btn.closest('.video-wrapper');
      const video = wrapper && wrapper.querySelector('video');
      if (video) { video.play(); btn.style.display = 'none'; }
    });
  });
}

// ---- Infinite Scroll (basic) ----
function initInfiniteScroll() {
  const grid = $('.products-grid[data-infinite-scroll]');
  if (!grid) return;
  let page = 2;
  let loading = false;
  let hasMore = grid.dataset.hasMore !== 'false';

  const sentinel = document.createElement('div');
  sentinel.style.height = '1px';
  grid.after(sentinel);

  const io = new IntersectionObserver(async entries => {
    if (!entries[0].isIntersecting || loading || !hasMore) return;
    loading = true;
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('page', page);
      const res = await fetch(url.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
      const text = await res.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(text, 'text/html');
      const newCards = doc.querySelectorAll('.product-card');
      if (newCards.length === 0) { hasMore = false; io.disconnect(); return; }
      newCards.forEach(card => grid.appendChild(card));
      initQuickAdd();
      initWishlist();
      page++;
    } catch(e) { console.error(e); }
    finally { loading = false; }
  }, { rootMargin: '200px' });

  io.observe(sentinel);
}

// ---- Recently Viewed ----
const RV_KEY = 'beautiq_recently_viewed';

function trackRecentlyViewed() {
  const pid = document.body.dataset.productId;
  if (!pid) return;
  try {
    let rv = JSON.parse(localStorage.getItem(RV_KEY) || '[]');
    rv = rv.filter(id => id !== pid);
    rv.unshift(pid);
    rv = rv.slice(0, 10);
    localStorage.setItem(RV_KEY, JSON.stringify(rv));
  } catch {}
}

// ---- Newsletter ----
function initNewsletter() {
  $$('.newsletter__form, .footer-newsletter-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const email = form.querySelector('input[type="email"]');
      if (!email || !email.value) return;
      showToast('Thank you for subscribing!', 'success');
      form.reset();
    });
  });
}

// ---- Compare (basic) ----
const COMPARE_KEY = 'beautiq_compare';
const MAX_COMPARE = 4;

function initCompare() {
  $$('[data-compare]').forEach(btn => {
    btn.addEventListener('click', () => {
      const pid = btn.dataset.compare;
      try {
        let list = JSON.parse(localStorage.getItem(COMPARE_KEY) || '[]');
        if (list.includes(pid)) {
          list = list.filter(id => id !== pid);
          showToast('Removed from compare');
        } else if (list.length >= MAX_COMPARE) {
          showToast(`You can compare up to ${MAX_COMPARE} items`, 'error');
          return;
        } else {
          list.push(pid);
          showToast('Added to compare');
        }
        localStorage.setItem(COMPARE_KEY, JSON.stringify(list));
        btn.classList.toggle('active');
      } catch {}
    });
  });
}

// ---- DOMContentLoaded ----
document.addEventListener('DOMContentLoaded', () => {
  initAnnouncementSlider();
  initHeader();
  initMobileNav();
  initSearch();
  initCartDrawer();
  initHeroSlider();
  initProductSliders();
  initCountdowns();
  initBrandMarquee();
  initScrollAnimations();
  initCollectionFilters();
  initQuickAdd();
  initWishlist();
  initBeforeAfter();
  initCartCoupon();
  initVideoSection();
  initInfiniteScroll();
  trackRecentlyViewed();
  initNewsletter();
  initCompare();
  initProductPage();

  // Initialize cart count on load
  fetch('/cart.js').then(r => r.json()).then(c => {
    updateCartCount(c.item_count);
    updateShippingProgress(c.total_price);
  }).catch(() => {});
});